/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../app/dialog/dialog.actions';
import { ICreateMeetingButtonProps } from './types';

export const CreateMeetingButton: FunctionComponent<ICreateMeetingButtonProps> = ({
  label,
  title,
  className = 'btn btn-md popup_button',
  showIcon = true,
}) => {
  const dispatch = useDispatch();

  const openMeetingTemplatesFormDialog = useCallback(() => {
    dispatch(openDialog('meetingTemplatesFormDialog'));
  }, [dispatch]);

  const buttonTitle = title ?? label;

  return (
    <a className={className} title={buttonTitle} onClick={openMeetingTemplatesFormDialog}>
      {showIcon && <i className="icon-plus mr-1"></i>}
      {label}
    </a>
  );
};
